import { cva } from "cva";

export const statDescriptionStyles = cva("", {
  defaultVariants: {
    appearance: "light",
  },
  variants: {
    appearance: {
      light: "text-gray-800",
      dark: "text-gray-300",
      brand: "text-gray-100",
    },
  },
});

export const statValueStyles = cva("order-first", {
  defaultVariants: {
    appearance: "light",
  },
  variants: {
    appearance: {
      light: "text-gray-900",
      dark: "text-white",
      brand: "text-white",
    },
  },
});

export const statContainerStyles = cva("", {
  defaultVariants: {
    appearance: "light",
  },
  variants: {
    appearance: {
      light: "bg-gray-400/10",
      dark: "bg-gray-400/10",
      brand: "bg-white/10",
    },
  },
});
